import Database from "../services/Database";
import Event from '../Event';
export class PermissionUtils {
    static async triggerNotificationPermissionChanged(updateIfIdentical = false) {
        const newPermission = await OneSignal.privateGetNotificationPermission();
        const previousPermission = await Database.get('Options', 'notificationPermission');
        const shouldBeUpdated = newPermission !== previousPermission || updateIfIdentical;
        if (!shouldBeUpdated) {
            return;
        }
        await Database.put('Options', { key: 'notificationPermission', value: newPermission });
        Event.trigger(OneSignal.EVENTS.NATIVE_PROMPT_PERMISSIONCHANGED, { to: newPermission });
    }
}
//# sourceMappingURL=PermissionUtils.js.map